import { Flex } from '@/ui/Flex/Flex';
import { T } from '@/ui/Text/Text';
import { memo } from 'react';
import { useIntl } from 'react-intl';
import { Position } from '@xyflow/react';
import { ActionDispatchCustomEventNodeType } from '../types';
import BaseNode from '../BaseNode';
import ActionHandle from '../ActionHandle';

export const ActionDispatchCustomEventNode = memo(
  ({
    data,
    selected,
    disabled,
  }: {
    data: ActionDispatchCustomEventNodeType['data'];
    selected?: boolean;
    disabled?: boolean;
  }) => {
    const intl = useIntl();
    return (
      <BaseNode
        selected={selected ?? false}
        type="action"
        isValid={data.isValid}
        disabled={disabled}
      >
        <Flex direction="column">
          <T h4>
            {intl.formatMessage({
              defaultMessage: 'Dispatch Custom Event',
              id: 'sOUA1M',
            })}
          </T>
          <T body2>
            {data.options.eventName ||
              intl.formatMessage({
                defaultMessage: 'Event Name',
                id: 'n5Q9H0',
              })}
          </T>
        </Flex>
        <ActionHandle
          type="target"
          position={Position.Left}
          disabled={disabled}
        />
        <ActionHandle
          type="source"
          position={Position.Right}
          disabled={disabled}
        />
      </BaseNode>
    );
  },
);

export default ActionDispatchCustomEventNode;
